"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var surveyChecks_exports = {};
__export(surveyChecks_exports, {
  approveWithAnyTeam: () => approveWithAnyTeam,
  approveWithTeam: () => approveWithTeam,
  copy: () => copy,
  createWithAnyTeam: () => createWithAnyTeam,
  createWithTeam: () => createWithTeam,
  hasProjectQualifications: () => hasProjectQualifications,
  hasRequiredRole: () => hasRequiredRole,
  refreshMetadata: () => refreshMetadata,
  remove: () => remove,
  submit: () => submit,
  updateData: () => updateData,
  updateStatus: () => updateStatus,
  updateSurveyor: () => updateSurveyor,
  view: () => view
});
module.exports = __toCommonJS(surveyChecks_exports);
var import_guard = require("@cartographerio/guard");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_create = require("../check/create.js");
var import_check = require("../check/index.js");
const updateableStatuses = ["draft", "complete", "review"];
const failSurveyLocked = import_check.check.never("Approved surveys cannot be modified. Unapprove the survey first");
function view(project) {
  if (project == null) {
    return import_check.check.named(`List/view surveys across all projects`, import_check.check.globalAdmin);
  } else {
    const named = (body) => import_check.check.named(`List/view surveys in project ${project.id}`, body);
    switch (project.projectVisibility) {
      case "Private":
        return named(
          import_check.check.and(
            import_check.check.workspaceReadOnlyAccess(project.workspaceId),
            import_check.check.projectMember(project.id, project.workspaceId, project.teamIds)
          )
        );
      case "Workspace":
        return named(
          import_check.check.and(import_check.check.workspaceReadOnlyAccess(project.workspaceId), import_check.check.workspaceActive(project.workspaceId))
        );
      default:
        return (0, import_util.checkExhausted)(project.projectVisibility);
    }
  }
}
function hasRequiredRole(roleName, project, teamId) {
  return import_check.check.named(
    "Has required role",
    import_check.check.or(
      import_check.check.workspaceAdmin(project.workspaceId),
      import_check.check.hasRole((0, import_types.projectRole)(roleName, project.id)),
      teamId == null ? import_check.check.never() : import_check.check.hasRole((0, import_types.teamRole)(roleName, teamId))
    )
  );
}
function createWithAnyTeam(project) {
  return import_check.check.named(
    `Create surveys in ${project.name} (any team)`,
    import_check.check.and(
      import_check.check.workspaceFullAccess(project.workspaceId),
      hasProjectQualifications(project),
      import_check.check.projectSurveyor(project.permissionModel, project.id, project.workspaceId, project.teamIds)
    )
  );
}
function createWithTeam(project, teamId) {
  return import_check.check.named(
    `Create surveys in ${project.name} (${teamId == null ? "no team" : teamId})`,
    surveyUpdateableOr({
      project,
      survey: { teamId, status: "draft" },
      surveyorCheck: import_create.always,
      firstPartyCheck: import_check.check.projectSurveyor,
      thirdPartyCheck: import_check.check.projectApprover,
      orElse: failSurveyLocked
    })
  );
}
function copy(fromProject, toProject, fromTeamId, toTeamId) {
  const description = [
    `Copy survey from ${fromProject.name} `,
    `(${fromTeamId ? `team ${fromTeamId}` : "no team"}) `,
    `to project ${toProject.name} `,
    `(${toTeamId ? `team ${toTeamId}` : "no team"})`
  ].join(" ");
  return import_check.check.named(description, import_check.check.and(view(fromProject), createWithTeam(toProject, toTeamId)));
}
function updateStatus(project, survey) {
  const description = [
    `Change status of survey ${survey.id}`,
    `in project ${project.name}`,
    `(${survey.teamId ? `team ${survey.teamId}` : `no team`})`,
    `(currently ${survey.status})`
  ].join(" ");
  return import_check.check.named(
    description,
    surveyUpdateableOr({
      project,
      survey,
      surveyorCheck: userIsSurveyor(survey.surveyor),
      firstPartyCheck: import_check.check.projectSurveyor,
      thirdPartyCheck: import_check.check.projectApprover,
      orElse: import_check.check.and(
        import_check.check.workspaceFullAccess(project.workspaceId),
        hasProjectQualifications(project),
        import_check.check.projectApprover(project.permissionModel, project.id, project.workspaceId, survey.teamId)
      )
    })
  );
}
function submit(project, teamId) {
  return import_check.check.named(
    [`Submit survey in project ${project.name}`, `(${teamId ? `team ${teamId}` : `no team`})`].join(""),
    import_check.check.and(
      import_check.check.workspaceFullAccess(project.workspaceId),
      import_check.check.projectSurveyor(project.permissionModel, project.id, project.workspaceId, teamId)
    )
  );
}
function approveWithAnyTeam(project) {
  const description = `Approve surveys in project ${project.name} (any team)`;
  return import_check.check.named(
    description,
    import_check.check.and(
      import_check.check.workspaceFullAccess(project.workspaceId),
      import_check.check.projectApprover(project.permissionModel, project.id, project.workspaceId, project.teamIds)
    )
  );
}
function approveWithTeam(project, teamIds) {
  const teamDescription = (0, import_guard.isArray)(teamIds) ? teamIds.length === 0 ? "no team" : teamIds.join(", ") : teamIds == null ? "no team" : teamIds;
  const description = `Approve survey in project ${project.name} (${teamDescription})`;
  return import_check.check.named(
    description,
    import_check.check.and(
      import_check.check.workspaceFullAccess(project.workspaceId),
      import_check.check.projectApprover(project.permissionModel, project.id, project.workspaceId, teamIds)
    )
  );
}
function updateSurveyor(project, survey) {
  return import_check.check.named(
    `Update surveyor in ${survey.id}`,
    surveyUpdateableOr({
      project,
      survey,
      surveyorCheck: userIsSurveyor(survey.surveyor),
      firstPartyCheck: import_check.check.projectApprover,
      thirdPartyCheck: import_check.check.projectApprover,
      orElse: failSurveyLocked
    })
  );
}
function updateData(project, survey) {
  return import_check.check.named(
    `Update data in ${survey.id}`,
    surveyUpdateableOr({
      project,
      survey,
      surveyorCheck: userIsSurveyor(survey.surveyor),
      firstPartyCheck: import_check.check.projectSurveyor,
      thirdPartyCheck: import_check.check.projectApprover,
      orElse: failSurveyLocked
    })
  );
}
function remove(project, survey) {
  return import_check.check.named(
    `Delete survey ${survey.id}`,
    surveyUpdateableOr({
      project,
      survey,
      surveyorCheck: userIsSurveyor(survey.surveyor),
      firstPartyCheck: import_check.check.projectSurveyor,
      thirdPartyCheck: import_check.check.projectApprover,
      orElse: failSurveyLocked
    })
  );
}
function refreshMetadata() {
  return import_check.check.named(`Refresh survey metadata`, import_check.check.superuser);
}
function hasProjectQualifications(project) {
  return import_check.check.named(
    "User is qualified",
    import_check.check.and(
      ...project.qualificationRequirements.map(
        ({ qualificationId, name }) => import_check.check.hasQualification((0, import_types.qualificationRole)(name, qualificationId))
      )
    )
  );
}
function userIsSurveyor(surveyor) {
  return surveyor?.userId != null ? import_check.check.hasUserId(surveyor.userId) : (0, import_create.never)("Cannot save a survey with no surveyor");
}
function surveyUpdateableOr({
  project,
  survey,
  surveyorCheck,
  firstPartyCheck,
  thirdPartyCheck,
  orElse
}) {
  return updateableStatuses.includes(survey.status) ? import_check.check.and(
    import_check.check.workspaceFullAccess(project.workspaceId),
    hasProjectQualifications(project),
    import_check.check.or(
      thirdPartyCheck(project.permissionModel, project.id, project.workspaceId, survey.teamId),
      import_check.check.named(
        `User is current owner of survey ${survey.id}`,
        import_check.check.and(
          surveyorCheck,
          firstPartyCheck(project.permissionModel, project.id, project.workspaceId, survey.teamId)
        )
      )
    )
  ) : orElse;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  approveWithAnyTeam,
  approveWithTeam,
  copy,
  createWithAnyTeam,
  createWithTeam,
  hasProjectQualifications,
  hasRequiredRole,
  refreshMetadata,
  remove,
  submit,
  updateData,
  updateStatus,
  updateSurveyor,
  view
});
//# sourceMappingURL=surveyChecks.js.map
